import React from "react";
import { successDeliveries } from "../data/requirementsData";
import Button from "Components/Common/Button/Button";

interface SuccessPageProps {
  projectData: any;
  gcName: string;
  onContinue?: () => void;
}

const SuccessPage = ({ projectData, gcName, onContinue }: SuccessPageProps) => (
  <div className="successPage">
    <div className="successPage__circle">✅</div>
    <h2 className="successPage__title">Requirements Acknowledged</h2>
    <p className="successPage__sub">
      You have reviewed and acknowledged all project requirements for{" "}
      <strong>{projectData?.projectName ?? ""}</strong>. Your signed
      acknowledgment has been recorded and delivered to{" "}
      <strong>{projectData?.lender?.companyName ?? ""}</strong> and{" "}
      {`${projectData?.admin?.firstName ?? ""} ${projectData?.admin?.lastName ?? ""}`.trim()}
      .
    </p>

    <div className="successPage__list">
      <div className="successPage__listTitle">Delivered To</div>
      <div className="successPage__listItem">
        <span className="successPage__check">✓</span>
        <span>
          {projectData?.lender?.companyName ?? ""} — Lending file updated
        </span>
      </div>
      <div className="successPage__listItem">
        <span className="successPage__check">✓</span>
        <span>
          Admin —{" "}
          {`${projectData?.admin?.firstName ?? ""} ${projectData?.admin?.lastName ?? ""}`.trim()}{" "}
          Notified
        </span>
      </div>
      <div className="successPage__listItem">
        <span className="successPage__check">✓</span>
        <span>
          {`${projectData?.owner?.firstName ?? ""} ${projectData?.owner?.lastName ?? ""}`.trim()}{" "}
          — Owner notified
        </span>
      </div>
      {successDeliveries.map((item, i) => (
        <div key={i} className="successPage__listItem">
          <span className="successPage__check">✓</span>
          {item}
        </div>
      ))}
    </div>

    <Button className="successPage__nextBtn" type="button" onClick={onContinue}>
      Continue to Pre-Con Checklist →
    </Button>
  </div>
);

export default SuccessPage;
